import { useNavigate } from 'react-router-dom'
import useHomeCard from './useHomeCard'
import { useTourContext } from '../../../context/TourContext'
import { useAuthContext } from '../../../context'

const HomeCard = ({ card, className = '', index }) => {
  const navigate = useNavigate()
  const { userDetails } = useAuthContext()
  const { handleMouseEnter, handleMouseLeave, containerClass, isHovering } =
    useHomeCard()
  const { handleNextTourStep } = useTourContext()
  return (
    <div
      id={`home-card-${index}`}
      className={containerClass}
      onClick={() => {
        navigate(card.to)
        if (index === 0 && !userDetails?.tutorial) {
          handleNextTourStep()
        }
      }}
    >
      <div className="flipper w-full h-full  relative">
        <div
          className={`rounded relative flex cursor-pointer w-full h-0 pb-[100%] text-center text-over-primary-background ${className}`}
          onMouseOver={handleMouseEnter}
          onMouseOut={handleMouseLeave}
          onTouchStart={handleMouseEnter}
          onTouchEnd={handleMouseLeave}
          style={{
            WebkitBackfaceVisibility: 'hidden',
            MozBackfaceVisibility: 'hidden',
            OBackfaceVisibility: 'hidden',
            backfaceVisibility: 'hidden',
            transition: '0.3s all ease',
            backgroundColor: card.backgroundColor,
          }}
        >
          <div
            className="top-[50%] left-[50%]  absolute font-bold text-lg"
            style={{ transform: 'translate(-50%,-50% )' }}
          >
            {card.icon}
            <div className="mt-[30px] font-bold text-nowrap text-sm md:text-lg">
              {card.name}
            </div>
          </div>
        </div>
        <div
          className="cursor-pointer text-center rounded w-full pb-[100%] h-0 absolute top-0 left-0 text-over-primary-background"
          style={{
            WebkitBackfaceVisibility: 'hidden',
            MozBackfaceVisibility: 'hidden',
            OBackfaceVisibility: 'hidden',
            backfaceVisibility: 'hidden',
            transition: '0.3s all ease',
            color: card.color,
            backgroundColor: card.backgroundColor,
            WebkitTransform: 'rotateY(180deg)',
            MozTransform: 'rotateY(180deg)',
            OTransform: 'rotateY(180deg)',
            transform: 'rotateY(180deg)',
          }}
        >
          <p
            style={{ transform: 'translateY(-50%)' }}
            className="top-[50%] absolute font-bold text-sm xxl:text-lg p-3"
          >
            {card.description}
          </p>
        </div>
      </div>
    </div>
  )
}

export default HomeCard
